import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BancoBi } from 'app/resources/bi/banco.bi';
import { EnumBi } from 'app/resources/bi/enum.bi';
import { VoucherBi } from 'app/resources/bi/voucher.bi';
import { Banco } from 'app/resources/classes/banco';
import { Cartao } from 'app/resources/classes/cartao';
import { Conta } from 'app/resources/classes/conta';
import { Rotas } from 'app/resources/classes/rotas';
import { VouchersParaConta } from 'app/resources/classes/vouchersParaConta';
import { EnumTipoDeDocumento } from 'app/resources/enum/enumTipoDeDocumento';
import { HttpService } from 'app/resources/services';
import { AlertService } from 'app/resources/services/alert.service';
import { VoucherService } from 'app/resources/services/voucher.service';

@Component({
  selector: 'app-voucher-dados-transferencia',
  templateUrl: './voucher-dados-transferencia.component.html'
})

export class VoucherDadosTransferenciaComponent implements OnInit {

  public documentoTipo: string;
  public conta: Conta;
  public bancos: Array<Banco>;
  public banco: Banco;
  public vouchersParaResgate: Array<Cartao>;
  public readonly enumTipoDeDocumento = EnumTipoDeDocumento;

  constructor(private httpService: HttpService, private router: Router, private voucherService: VoucherService, private alertService: AlertService) { }

  ngOnInit() {
    this.conta = new Conta();
    this.banco = new Banco();
    this.documentoTipo = this.enumTipoDeDocumento.CPF;
    this.atualizaBancos();
  }

  public resgatar(): void {
    this.vouchersParaResgate = [];
    if (this.voucherService.vouchersAdicionais.length > 0) {
      const clone: Array<Cartao> = [];
      this.vouchersParaResgate = Object.assign(clone, this.voucherService.vouchersAdicionais);
    }
    this.conta.setBanco(this.banco);
    new VoucherBi.Rest(this.httpService).resgatar(new VouchersParaConta(this.vouchersParaResgate, this.conta))
      .subscribe(
        success => {
          this.vouchersParaResgate = undefined;
          this.router.navigate([Rotas.VOUCHER_SUCESSO]);
        },
        error => {
          this.vouchersParaResgate = undefined;
          this.alertService.errorAlert(error._body);
        });
  }

  private atualizaBancos(): void {
    this.bancos = undefined;
    new EnumBi.Rest(this.httpService).getBancos()
      .subscribe(
        success => {
          this.bancos = BancoBi.Parser.fillList(success.json());
        },
        error => {
          this.bancos = [];
          this.alertService.errorAlert(error._body);
          this.irParaTelaResgatarVouchers();
        }
      );
  }

  public irParaTelaResgatarVouchers(): void {
    this.router.navigate([Rotas.VOUCHER_RESGATAR]);
  }
}



// WEBPACK FOOTER //
// ./src/app/voucher/voucher-dados-transferencia/voucher-dados-transferencia.component.ts